import { useState } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { Smartphone, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const STAFF = ["admin", "manager", "sales", "sales_manager"];

export const isMobileDevice = () =>
  typeof navigator !== "undefined" &&
  (/Android|iPhone|iPod|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 1 && window.matchMedia("(max-width: 900px)").matches));

const PUBLIC_PATHS = ["/forgot-password", "/reset-password", "/reference/", "/register"];

function mobilePathFor(pathname) {
  const m = pathname.match(/^\/crm\/customers\/([^/]+)/);
  if (m) return `/mobilecrm/customers/${m[1]}`;
  if (pathname === "/crm/pipeline") return "/mobilecrm/pipeline";
  return "/mobilecrm";
}

export function MobileVersionBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("hideMobileBanner") === "1");

  const mobile = isMobileDevice();
  if (mobile && user && STAFF.includes(user.role) && !pathname.startsWith("/mobilecrm") && !PUBLIC_PATHS.some((p) => pathname.startsWith(p))) {
    return <Navigate to={mobilePathFor(pathname)} replace />;
  }
  const onLogin = pathname === "/login" || pathname === "/";
  const eligible = user ? STAFF.includes(user.role) : onLogin;
  if (hidden || !eligible || pathname.startsWith("/mobilecrm") || !mobile) return null;

  const dismiss = () => { sessionStorage.setItem("hideMobileBanner", "1"); setHidden(true); };
  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] bg-[#0F172A] text-white px-4 pt-3 flex items-center gap-3 shadow-[0_-4px_16px_rgba(0,0,0,0.25)]"
      style={{ paddingBottom: "max(env(safe-area-inset-bottom), 12px)" }} data-testid="mobile-version-banner">
      <Smartphone className="h-5 w-5 text-[#D4AF37] shrink-0" />
      <p className="flex-1 text-xs leading-snug text-zinc-300">On a phone?</p>
      <button onClick={() => navigate("/mobilecrm")} data-testid="use-mobile-version-btn"
        className="shrink-0 bg-[#D4AF37] text-[#0F172A] px-3 py-2 text-xs font-bold uppercase tracking-wide">Use the Mobile Version</button>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="mobile-version-dismiss" className="shrink-0 p-1 text-zinc-400"><X className="h-4 w-4" /></button>
    </div>
  );
}
